import { App } from 'vue';
import { VueSlickgrid, VueSlickgridColumnSelector } from '@integro/slickg';
import { registerFormatters } from './formatters';

export function installSlickDatagrid(app: App) {
  registerFormatters();
  app.component('VueSlickgrid', VueSlickgrid);
  app.component('VueSlickgridColumnSelector', VueSlickgridColumnSelector);
}
